var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FormBuilder, Validators } from '@angular/forms';
import { I18nService } from '@app/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/auth.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(Auth, route, router, i18nService, util, apiService, fb) {
        this.Auth = Auth;
        this.route = route;
        this.router = router;
        this.i18nService = i18nService;
        this.util = util;
        this.apiService = apiService;
        this.fb = fb;
        this.isLoading = false;
        this.submitted = false;
        this.returnUrl = "";
        this.form = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }
    Object.defineProperty(LoginComponent.prototype, "formControl", {
        get: function () {
            return this.form.controls;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.handleKeyboardEvent = function (event) {
        if (event.key == "Enter") {
            this.Login();
        }
    };
    LoginComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var ck, getKeyRes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
                        ck = JSON.parse(localStorage.getItem("dpa_cc"));
                        if (ck == null) {
                            localStorage.setItem("dpa_cc", "{}");
                            this.cookieData = {};
                        }
                        else {
                            this.cookieData = ck;
                        }
                        return [4 /*yield*/, this.apiService.getKey()];
                    case 1:
                        getKeyRes = _a.sent();
                        this.cookieData.pbk = getKeyRes;
                        localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData));
                        this.route.queryParams.subscribe(function (params) {
                            _this.cookieUser = params['user'];
                            _this.cookiePass = params['pass'];
                        });
                        if (this.cookieUser != null && this.cookieUser != undefined) {
                            this.form.controls["username"].setValue(this.cookieUser);
                            this.form.controls["password"].setValue(this.cookiePass);
                            this.Login();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.Login = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, user_1, roleList, role, dpa_cc, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 11, , 12]);
                        this.submitted = true;
                        if (!this.form.valid) return [3 /*break*/, 10];
                        this.util.ShowWaiting(true);
                        return [4 /*yield*/, this.apiService.post("crmservice", "callcenterLogin", this.form.value)];
                    case 1:
                        res = _a.sent();
                        if (!this.util.isSuccessResponse(res)) return [3 /*break*/, 9];
                        if (!(res.RESCODE == "0" && res.RESMSG == "SUCCESS")) return [3 /*break*/, 2];
                        this.loginCallcenter();
                        return [3 /*break*/, 8];
                    case 2:
                        if (!(res.RESCODE == "Y" && res.RESMSG == "SUCCESS")) return [3 /*break*/, 7];
                        if (!(this.cookieUser != null && this.cookieUser != undefined)) return [3 /*break*/, 3];
                        this.loginCallcenter();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", "username=" + this.form.get("username").value)];
                    case 4:
                        user_1 = _a.sent();
                        return [4 /*yield*/, this.apiService.get("master", "customwebrole")];
                    case 5:
                        roleList = _a.sent();
                        role = roleList.filter(function (r) {
                            return r.dpa_customwebroleid == user_1[0].dpa_roleid;
                        });
                        dpa_cc = {
                            "userId": user_1[0].dpa_customwebuserid,
                            "userRole": role[0].dpa_customwebroleid,
                            "username": this.form.get("username").value,
                            "role": JSON.stringify(role[0]),
                            "dpa_name": user_1[0].dpa_name,
                            "teams": JSON.stringify(user_1[0].dpa_teamidlist)
                        };
                        localStorage.setItem("dpa_cc", JSON.stringify(dpa_cc));
                        localStorage.setItem("returnUrl", this.returnUrl);
                        localStorage.setItem("role", JSON.stringify(role[0]));
                        this.router.navigate(["/setChangePassword"]);
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง");
                        _a.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        this.util.ErrorDialog("Username หรือ Password ไม่ถูกต้อง");
                        _a.label = 10;
                    case 10:
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 12];
                    case 11:
                        ex_1 = _a.sent();
                        this.util.ShowWaiting(false);
                        this.util.ErrorDialog(ex_1);
                        return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.CheckSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var str, data, res, check, res2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        str = '';
                        $('#divData').html(str);
                        data = {};
                        data['member_no'] = $('#txtUserName').val();
                        return [4 /*yield*/, this.apiService.postnotauthen('account', 'GetUserSession', data)];
                    case 1:
                        res = _a.sent();
                        this.util.ShowWaiting(false);
                        check = 0;
                        if (res.isSuccess) {
                            if (res.responseData != null) {
                                if (res.responseData.length > 0) {
                                    check++;
                                    this.ip_add = res.responseData[0].ip_address;
                                }
                            }
                        }
                        if (!(check == 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.apiService.postnotauthen('account', 'InsertUserSession', data)];
                    case 2:
                        res2 = _a.sent();
                        this.VisitApp(this.url);
                        return [3 /*break*/, 4];
                    case 3:
                        this.util.ErrorDialog("user นี้ถูกใช้งานอยู่ (ip:" + this.ip_add + ")");
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginComponent.prototype.VisitApp = function (url) {
        // window.location.href = url;
        this.router.navigate([url]);
    };
    LoginComponent.prototype.setLanguage = function (language) {
        this.i18nService.language = language;
    };
    Object.defineProperty(LoginComponent.prototype, "currentLanguage", {
        get: function () {
            return this.i18nService.language;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginComponent.prototype, "languages", {
        get: function () {
            return this.i18nService.supportedLanguages;
        },
        enumerable: true,
        configurable: true
    });
    LoginComponent.prototype.resetPassword = function () {
        var url = this.util.baseUrl() + "/resetPassword";
        window.open(url, "_blank");
    };
    LoginComponent.prototype.clear = function () {
        this.form.controls["username"].setValue("");
        this.form.controls["password"].setValue("");
        this.submitted = false;
    };
    LoginComponent.prototype.loginCallcenter = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, roleList, role, dpa_cc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", "username=" + this.form.get("username").value)];
                    case 1:
                        user = _a.sent();
                        return [4 /*yield*/, this.apiService.get("master", "customwebrole")];
                    case 2:
                        roleList = _a.sent();
                        role = roleList.filter(function (r) {
                            return r.dpa_customwebroleid == user[0].dpa_roleid;
                        });
                        dpa_cc = {
                            "userId": user[0].dpa_customwebuserid,
                            "userRole": role[0].dpa_customwebroleid,
                            "username": this.form.get("username").value,
                            "role": JSON.stringify(role[0]),
                            "dpa_name": user[0].dpa_name,
                            "teams": JSON.stringify(user[0].dpa_teamidlist)
                        } //role[0].dpa_name
                        ;
                        localStorage.setItem("dpa_cc", JSON.stringify(dpa_cc));
                        this.util.ShowWaiting(false);
                        if (this.returnUrl) {
                            this.router.navigateByUrl(this.returnUrl);
                        }
                        else if (role[0].dpa_tab_poolcase) {
                            this.router.navigate(["/mainmenu/pool"]);
                        }
                        else if (role[0].dpa_tab_allcase) {
                            this.router.navigate(["/mainmenu/shared"]);
                        }
                        else if (role[0].dpa_tab_case) {
                            this.router.navigate(["/mainmenu/case"]);
                        }
                        else if (role[0].dpa_tab_contact) {
                            this.router.navigate(["/mainmenu/contact"]);
                        }
                        else if (role[0].dpa_tab_chatbot) {
                            this.router.navigate(["/mainmenu/chatbot"]);
                        }
                        else if (role[0].dpa_tab_socialmonitoring) {
                            this.router.navigate(["/mainmenu/socialMedia"]);
                        }
                        else if (role[0].dpa_tab_km) {
                            this.router.navigate(["/mainmenu/knowledge"]);
                        }
                        else if (role[0].dpa_tab_report) {
                            this.router.navigate(["/mainmenu/report"]);
                        }
                        else {
                            this.router.navigate(["/mainmenu"]);
                            this.util.WarningDialog("คุณไม่มีสิทธิ์เข้าใช้เมนู");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts.pre-build-optimizer.js